@if (isLoading) {
	<div class="loading-overlay">
		<img class="spinner" src="./assets/spinner2.gif" />
	</div>
}

<div class="service-header-wrapper">
	<h2 class="mat-heading" style="flex: 2">{{ 'docs.sidebar.templates' | translate }}</h2>
	<div class="service-header-buttons">
		<div class="acies-density-high acies-list-search-field" style="margin-right: 1rem">
			<mat-form-field>
				<input matInput [placeholder]="'insights.administration.users.search' | translate" [(ngModel)]="templateFilterText" />
				<button mat-icon-button matPrefix>
					<mat-icon svgIcon="acies_search"></mat-icon>
				</button>
			</mat-form-field>
		</div>
		<div style="margin-right: 1.5rem">
			<mat-checkbox [(ngModel)]="showOnlyActive">
				{{ 'insights.administration.reports.onlyactive' | translate }}
			</mat-checkbox>
		</div>
		<header-sub-menu [favoriteItems]="favoriteItems" [menuItems]="menuItems"></header-sub-menu>
	</div>
</div>

<app-generictable
	#tableRef
	[hidden]="(count$ | async) <= 0"
	[tableData]="templateData | async"
	[tableColumns]="registerTableColumns"
	[pageSizes]="pageSizes"
	[initialPageSize]="initialPageSize"
	[showFirstLastButtons]="false"
	[filterWord]="templateFilter"
	[rowActions]="regRowActions"
	[selectActions]="regSelectActions"
	(menuEmitter)="handleRowMenuAction($event)"
	(paginatorEmitter)="handleReloadData($event)"
	[totalRowCount]="count$ | async"></app-generictable>
